import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntBasicHB } from "../handBooks/basicHB";
import { EntTypeProduct } from "../handBooks/typeProduct";
import { EntDirectoryInfoName } from "../directoryInfoName";

export class EntStorageRegister {
  id: number|null = null;
  regionId: number|null = null;
  areaId: number|null = null;
  territorialUnitId: number|null = null;

  storageName: string|null = null;
  legalEntity: string|null = null;
  ownershipTypeId: number|null = null;
  yearReported: number|null = null;

  longitude: number|undefined = undefined;
  latitude: number|undefined = undefined;

  registerStatusId: number|null = null;

  capacity: EntStorageCapacity|null = null;
  files?: EntFiles[];
  deleteFileIds?: number[];

  region?: EntTerritorialsUnits;
  area?: EntTerritorialsUnits;
  territorialUnit?: EntTerritorialsUnits;
  ownershipType?: EntDirectoryInfoName;
  registerStatus?: EntBasicHB;
  storageType?: EntBasicHB;
  productType?: EntTypeProduct;
}

export class EntStorageCapacity {
  id: number|null = null;
  storageRegisterId: number|null = null;
  capacityTonnes: number|null = null;
  coldStorageAvailable: boolean|null = null;
  coldStorageVolumeM3: number|null = null;
  temperatureControlled: boolean|null = null;
  insulatedWalls: boolean|null = null;
  ventilationSystem: boolean|null = null;
  productTypeId: number|null = null;
  storageTypeId: number|null = null;

  productType?: EntTypeProduct;
  storageType?: EntBasicHB;
}

export class EntFiles {
  id: number|null = null;
  name: string|null = null;
  path: string|null = null;
  pathCropped: string|null = null;
  extension: string|null = null;
  type: string|null = null;
  createdTime: string|null = null;
}